import {RegionType} from '@shared/cci/features/const/environment';

export function getDatadogScript(region: RegionType) {
  return `
      <script
      src="https://www.datadoghq-browser-agent.com/us1/v6/datadog-rum.js"
      type="text/javascript"
    ></script>
    <script>
      if (window.DD_RUM) {
        window.DD_RUM.init({
          clientToken: '${import.meta.env.VITE_DATADOG_CLIENT_TOKEN}',
          applicationId: '${import.meta.env.VITE_DATADOG_APPLICAITION_ID}',
          site: 'datadoghq.com',
          service: 'di-app-fo-fe',
          env: '${import.meta.env.VITE_PROFILE}',
          // Specify a version number to identify the deployed version of your application in Datadoggtgt
          defaultPrivacyLevel: 'allow', // 모든 사용자 입력과 페이지 내용을 수집
          version: '${import.meta.env.CI_COMMIT_TAG}',
          sessionSampleRate: 100, // 모니터링할 사용자 세션의 백분율
          sessionReplaySampleRate: 100, // 세션 재생(Session Replay) 기능에 대한 샘플링 비율
          trackResources: true, // 페이지에서 로드되는 리소스(이미지, 스크립트, CSS 파일 등)를 추적할지 여부
          trackLongTasks: true, // 브라우저 메인 스레드를 50ms 이상 차단하는 장기 작업(Long Tasks)을 추적할지 여부
          trackUserInteractions: true, // 클릭, 탭, 스크롤과 같은 사용자 상호작용을 추적할지 여부
          allowedTracingUrls: [
            (url) => url.startsWith(window.location.origin),
            (url) => url.startsWith('${import.meta.env.VITE_CCI_KR_API_URL}'), // 추적할 URL(없으면 추적되지 않음)
            (url) => url.startsWith('${import.meta.env.VITE_DI_KR_API_URL}'), // 추적할 URL(없으면 추적되지 않음)
          ],
          beforeSend: (event, context) => {
            if (
              event.type === 'error' &&
              event.error &&
              event.error.message === 'Uncaught "Script error."' &&
              event.error.stack?.includes('undefined @')
            ) {
              return false; // 해당 에러는 무시(FE에러 x)
            }
            if (event?.resource?.type === 'xhr' && event.resource?.status_code !== 200) {
              const xhrResponse = context?.xhr?.response || {};
              event.context = {
                ...event.context,
                url: event?.resource.url,
                message: xhrResponse,
              };
            }

            return true;
          },
        });

        window.DD_RUM.setGlobalContextProperty('platform', '${import.meta.env.VITE_PLATFORM}');
        window.DD_RUM.setGlobalContextProperty('region', '${region}');
      }
    </script>
  `;
}

export function getDatadogSessionId() {
  if (window.DD_RUM && window.DD_RUM.getInternalContext()) {
    return window.DD_RUM.getInternalContext()?.session_id || '';
  }
  return;
}

export function setDatadogGlobalContextProperty(key: string, value: string) {
  if (window.DD_RUM) {
    return window.DD_RUM.setGlobalContextProperty(key, value);
  }
  return;
}

export function setDatadogUser(id: string) {
  if (window.DD_RUM) {
    return window.DD_RUM.setUser({id});
  }
  return;
}
